import { AccountingDocumentFormSettingComponent } from './accounting-document/accounting-document-form-setting/accounting-document-form-setting.component';
import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { SharedModule } from "projects/sepidz-web-framework-shell/src/lib/shared/shared.module";
import { SepidzGridModule } from "projects/sepidz-web-framework-data-grid/src/lib/grid.module";
import { ThemeModule } from "projects/sepidz-web-framework-shell/src/lib/@theme/theme.module";
import { DriverSettlementFormComponent } from "./driversettlement/driversettlement-form/driversettlement-form.component";
import { DriverSettlementListComponent } from "./driversettlement/driversettlement-list/driversettlement-list.component";
import { PaymentMethodFormComponent } from "./paymentmethod/payment-method-form/payment-method-form.component";
import { PaymentMethodListComponent } from "./paymentmethod/payment-method-list/payment-method-list.component";
import { InvoicesModalComponent } from "./driversettlement/invoicesmodal/invoicesmodal.component";
import { CashierSettlementFormComponent } from "./driversettlement/cashiersettlement-form/cashiersettlement-form.component";
import { CasheirSettlementListComponent } from "./driversettlement/cashiersettlement-list/casheirsettlement-list.component";
import { SettlementFormSettingFormComponent } from "./driversettlement/cashiersettlement-form/settlementformsetting/settlementformsetting-form.component";
import { AccountingSettingListComponent } from "./accounting-setting/accounting-setting-list/accounting-setting-list.component";
import { AccountingSettingFormComponent } from "./accounting-setting/accounting-setting-form/accounting-setting-form.component";
import { DriversettlementsettingFormComponent } from "./driversettlement/driversettlementsetting-form/driversettlementsetting-form.component";
import { DriverSettlementMenuComponent } from "./driversettlement/driverSettlementSetting";
import { AccountingDocumentFormComponent } from "./accounting-document/accounting-document-form/accounting-document-form.component";
import { AccountingDocumentListComponent } from "./accounting-document/accounting-document-list/accounting-document-list.component";
import { AccountingDocumentSettingMenuComponent } from './accounting-document/accounting-document-setting-menu.component';

const components = [
  DriverSettlementFormComponent,
  DriverSettlementListComponent,
  CashierSettlementFormComponent,
  CasheirSettlementListComponent,
  PaymentMethodFormComponent,
  PaymentMethodListComponent,
  InvoicesModalComponent,
  SettlementFormSettingFormComponent,
  AccountingSettingListComponent,
  AccountingSettingFormComponent,
  DriversettlementsettingFormComponent,
  DriverSettlementMenuComponent,
  AccountingDocumentFormComponent,
  AccountingDocumentListComponent,
  AccountingDocumentFormSettingComponent,
  AccountingDocumentSettingMenuComponent
];
@NgModule({
  declarations: [...components],
  exports: [...components],
  imports: [CommonModule, FormsModule, SharedModule.forRoot(), SepidzGridModule],
})
export class FinancialModule {}
